<template>
  <div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
      <h2 class="shadow" style="float: left;width:100%;">Bet Sizing Calculator</h2>
      <div style="width:100%;padding:12px;" v-if="errors.any() || error">
        <p class="error wrong_name error-box" v-if="errors.has('bankroll')">Bankroll is required</p>
        <p class="error wrong_name error-box" v-if="errors.has('odds')">Enter Odds in American Format</p>
        <p class="error wrong_email error-box" v-if="errors.has('edge')">Please enter a valid Edge number</p>
    </div>
      <div style="display:flex;flex-direction:column;float:left;width:100%;">
        <form>
          <div class="input-group">
            <label for="bankroll">Bankroll:</label>
            <input class="bankroll" style="position:relative" type="number" name="bankroll" maxlength="10" v-model="bankroll" v-validate="'required'" data-vv-delay="2000" autofocus/>
          </div>
          <div class="input-group">
            <label for="odds">American Odds:</label>
            <input type="text" name="odds" maxlength="10" v-model="odds" v-validate="'required|american_odds'" data-vv-delay="4000" autofocus/>
          </div>
          <div class="input-group">
            <label for="edge">Edge:</label>
            <input type="text" name="edge" maxlength="5" v-model="edge" v-validate="'required|decimal'" data-vv-delay="4000" autofocus/>
          </div>
          <div class="input-group" style="display:block;">
            <label for="risk">Risk Tolerance:</label>
            <select name="risk" v-model="selectedMultiplier" @change="multiplierChange" style="display:block;">
              <option v-for="(option, index) in multipliers" :key="index" :value="option">{{option}}</option>
            </select>
          </div>
          <div class="size-results">
            <p v-if="showOptimalBetSize" style="padding-bottom:6px;">Optimal Bet Size: ${{optimal.betSize}}</p>  
            <p v-if="showOptimalBetSize" style="font-size:14px;">{{optimal.percentage}} of Bankroll</p>
          </div>

          <div class="input-group">
            <input type="submit" value="Calculate" name="submitButton"
                                                   class="button submit" @click.prevent="calculate" />
          </div>
        </form>
      </div>
  </div>
  </div>
</template>

<script>
import Nav from '../components/Nav.vue'
import ToolRepository from '../data/tool.repository'

export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      multipliers: ['Conservative', 'Standard', 'Aggressive'],
      selectedMultiplier: 'Standard',
      bankroll: 1000,
      odds: '-150',
      edge: 5,
      optimal: { betSize: 0, percentage: 0 }
    }
  },
  methods: {
    multiplierChange () {
      this.optimal = Object.assign({}, this.optimal, {betSize: 0, percentage: 0})
    },
    calculate () {
      return this.$validator.validateAll().then((result) => {
        if (result) {
          const multiplier = this.multipliers.indexOf(this.selectedMultiplier)
          return ToolRepository.size({bankroll: this.bankroll, line: Number(this.odds), edge: this.edge / 100, multiplier}).then((response) => {
            this.optimal = Object.assign({}, this.optimal, {betSize: response.optimal_bet, percentage: response.optimal_percentage})
            console.log(this.optimal.betSize)
          })
        }
      }).catch((e) => {
        console.log(e)
      })
    }
  },
  computed: {
    showOptimalBetSize () {
      console.log('updating optimal bet size ', this.optimal.betSize)
      console.log(this.optimal.betSize > 0)
      return this.optimal.betSize > 0
    }
  }
}
</script>

<style lang="css" scoped>
p {
  font-size: 16px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}
label {
  font-size: 16px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}
input[type=text], input[type=number],
select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 4px;
  margin-bottom: 12px;
  resize: vertical;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}
.input-group {
  display: flex;
  flex-direction: column;
  position: relative;
}
input[type=submit] {
  margin: 16px auto;
  text-shadow: none;
  height: auto;
  position: relative;
  border-radius: 1000px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  min-width: 6rem;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-transition: color 0.20s ease, background-color 0.20s ease, border-color 0.20s ease;
  transition: color 0.20s ease, background-color 0.20s ease, border-color 0.20s ease;
  border: 0.125rem solid #003087;
  color: #ffffff;
  font-family: PayPalOpen-Bold, "Helvetica Neue", Arial, sans-serif;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 400;
  background: #003087;
  padding: 0.625rem 1.875rem;
}
.error {
  color: red !important;
}
.size-result {
  min-height: 35px;
}

</style>



// WEBPACK FOOTER //
// Size.vue?30f3b22e